export const INTERNAL_HEADER_HEIGHT = 70;
export const DEFAULT_INTERNAL_URL = '/dashboard';